import {svgIconWrapper} from '../svg-icon-wrapper';

import ParagraphRegular from './paragraph-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ParagraphRegular {...validProps} />;
}

SvgComponent.iconName = 'paragraph-regular';

export const ParagraphRegularIcon = svgIconWrapper(SvgComponent);
